import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/pengaturan")({
	component: Outlet,
});
